<script lang="ts">
	import { cleanCookies } from "@hitit/utils";
	sessionStorage.clear();
	localStorage.clear();
	cleanCookies();
	window.location.assign(`HITIT_HUB_URL`);

</script>
